module.exports = __webpack_public_path__ + "img/calender.ab51dfa5.svg";